<template>
  <div class="fill-height of-y" style="overflow-x: hidden; position: relative">
    <v-progress-linear style="position: absolute; top: 0; left: 0; width: 100%" class="ma-0" indeterminate v-if="saving"></v-progress-linear>
    <transition enter-active-class="scale-in-center" leave-active-class="scale-out-center" mode="out-in">
      <div class="c-d-flex c-align-center c-justify-center fill-height" v-if="loading" key="loading">
        <v-progress-circular
            :size="40"
            :width="3"
            color="secondary"
            indeterminate
        ></v-progress-circular>
      </div>
      <div v-else key="loaded" class="fill-height of-y c-d-flex c-flex-column" style="overflow-x: hidden">
        <v-data-table
            :headers="headers"
            :items="enabledUsers"
            item-key="id"
            class="fill-height scroll-table-with-foot ma-3"
            :rows-per-page-items="[{'text':'All','value':-1}, 5,10,25]"
            
        >
<!--          <template v-slot:items="{item}">-->
<!--            <td>-->
<!--              <div class="c-d-flex py-1 c-align-center">-->
<!--                <v-icon class="mr-3">{{ modelsRef[item.modelId].icon }}</v-icon>-->
<!--                <div class="c-flex-grow-1">-->
<!--                  <v-list-tile-sub-title>{{ modelsRef[item.modelId].ecosystem }}</v-list-tile-sub-title>-->
<!--                  <v-list-tile-title>{{ modelsRef[item.modelId].name }}</v-list-tile-title>-->
<!--                </div>-->
<!--              </div>-->
<!--            </td>-->
<!--&lt;!&ndash;            // mTokenInput&ndash;&gt;-->
<!--&lt;!&ndash;            // mTokenOutput&ndash;&gt;-->
<!--            <td class="text-xs-right">-->
<!--              {{ modelsRef[item.modelId].mTokenInput ? `R ${modelsRef[item.modelId].mTokenInput.toFixed(2)}` : '-' }}-->
<!--            </td>-->
<!--            <td class="text-xs-right">-->
<!--              {{ modelsRef[item.modelId].mTokenOutput ? `R ${modelsRef[item.modelId].mTokenOutput.toFixed(2)}` : '-' }}-->
<!--            </td>-->
<!--            <td class="text-xs-center" v-for="keyStr in ['taskChatEnabled', 'dashboardChatEnabled', 'mailChatEnabled', 'folderChatEnabled', 'workflowToolsEnabled', 'datasetToolsEnabled']">-->
<!--              <v-btn small icon>-->
<!--                <v-btn-->
<!--                    icon small flat-->
<!--                    :color="!item[keyStr] ? undefined : 'secondary'"-->
<!--                    class="pa-0 ma-0"-->
<!--                    @click="updateModelEnabled(item, keyStr)"-->
<!--                    :loading="pendingActions.includes(`${item.modelId}-${keyStr}`)"-->
<!--                    :disabled="pendingActions.includes(`${item.modelId}-${keyStr}`)"-->
<!--                >-->
<!--                  <v-icon>{{ item[keyStr] ? 'check_box' : 'check_box_outline_blank'}}</v-icon>-->
<!--                </v-btn>-->
<!--              </v-btn>-->
<!--            </td>-->
<!--          </template>-->
        </v-data-table>
      </div>
    </transition>
  </div>
</template>

<script>
import {validationRules} from "@/codeFunctions";
import format from "date-fns/format";

export default {
  props: {
    propName: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      loading: true,
      saving: false,
      enabledUsers: [],
      headers: [
        {text: 'User', align: 'left', value: 'fullname'},
      ],
      pendingActions: [],
      refreshEnabled: false,
      selectedUsers: []
    }
  },
  mounted() {
    this.loading = true
    this.startup()
        .finally(() => {
          this.loading = false
        })
  },
  watch: {
    saving(val) {
      if (!val) {
        // this.refreshEnabled = true
        // this.set(() => this.refreshEnabled = false)
      }
    }
  },
  methods: {
    format,
    
    async startup() {
      try {
        this.saving = true
        const { enabledUsers } = await this.$newReq('GET', `ai/admin/users/startup`)
        this.enabledUsers = enabledUsers
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        this.saving = false
      }
    },
    
    async updateModelEnabled(model, key) {
      try {
        
        const modelDefaultMap = {
          taskChatEnabled: 'taskChatDefault',
          dashboardChatEnabled: 'dashboardChatDefault',
          mailChatEnabled: 'mailChatDefault',
          folderChatEnabled: 'folderChatDefault',
          workflowToolsEnabled: 'workflowToolsDefault',
          datasetToolsEnabled: 'datasetToolsDefault'
        }
        
        const modelUpdate = {modelId: model.modelId}
        const newValue = !model[key]
        modelUpdate[key] = newValue
        if (!newValue)
          modelUpdate[modelDefaultMap[key]] = false
        
        this.pendingActions.push(`${model.modelId}-${key}`)
        
        await this.$newReq('POST', `ai/admin/models/upsert`, modelUpdate)
        this.startup()
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        await this.startup()
        this.saving = false
        this.pendingActions = this.pendingActions.filter(v => v !== `${model.modelId}-${key}`)
      }
    },
    
    async setDefaultModel(key, modelId) {
      try {
        this.saving = true
        
        const modelDefaultMap = {
          taskChatDefault: 'taskChatEnabled',
          dashboardChatDefault: 'dashboardChatEnabled',
          mailChatDefault: 'mailChatEnabled',
          folderChatDefault: 'folderChatEnabled',
          workflowToolsDefault: 'workflowToolsEnabled',
          datasetToolsDefault: 'datasetToolsEnabled'
        }
        
        await this.$newReq('POST', `ai/admin/models/setDefault`, {
          modelId,
          defaultKey: key,
          enabledKey: modelDefaultMap[key] || undefined
        })
        
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        await this.startup()
        this.saving = false
      }
    }
    
    
  },
  computed: {
    validationRules() {
      return validationRules
    },
    
    sortedModels() {
      return this.modelInfo.sort((a, b) => {
        if (a.ecosystem === b.ecosystem) return a.name.localeCompare(b.name)
        return a.ecosystem.localeCompare(b.name)
      })
    },
  },
}
</script>


<style scoped>

</style>